<script lang="ts" setup>
import { SupportProps } from "./Support.props"

const showAll = ref(false)
const { t } = useI18n()

defineProps<SupportProps>()
</script>

<template>
  <div class="support gap-x-12">
    <!-- FAQ Accordion -->
    <div
      v-if="questions?.length"
      class="support__accordion mb-10 flex flex-col gap-4 md:mb-0"
    >
      <h2
        v-if="!!title"
        class="dolphin-bold md:elephant-bold text-black-main mb-2"
      >
        {{ title }}
      </h2>
      <AppAccordion
        v-for="(item, index) in showAll ? questions : questions.slice(0, 6)"
        :key="`faq-accordion-${index}`"
        class="
          beaver-bold
          md:pig-bold
          text-black-80
          flex flex-col
          gap-2
          border-b
          pb-2
          [&_.accordion-header]:flex
          [&_.accordion-header]:justify-between
          [&_.accordion-icons]:shrink-0
          [&_.accordion-title-text]:text-left
        "
        :text="item.question"
        :is-open="null"
        with-icons
      >
        <template #icon-to-open>
          <UtilsIcon name="ChevronDown.svg" class="h-6 w-6" />
        </template>

        <template #icon-to-close>
          <UtilsIcon name="ChevronUp.svg" class="h-6 w-6" />
        </template>

        <template #body>
          <UtilsMarkdown
            v-if="item.answer"
            :content="item.answer"
            tag="div"
            class="mouse md:beaver"
          />
        </template>
      </AppAccordion>
      <div class="flex flex-row justify-center">
        <UtilsMarkdown
          v-if="!showAll && questions.length > 6"
          tag="div"
          :content="`${t('supportFaqs.showMoreQuestions')} (${
            questions.length - 6
          })`"
          @click="showAll = !showAll"
          role="button"
          tabindex="0"
          class="
            beaver-medium
            text-green-main
            border-green-main
            w-full
            whitespace-nowrap
            rounded-lg
            border
            px-24
            py-3
            text-center
            md:w-auto
            md:py-2
          "
        />
      </div>
    </div>
  </div>
</template>
